import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { omit } from '@/shared/utils/omit';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type CitizenshipCertificateGeneralFormType = PersonalIdentifierGeneralFormType;

export const CitizenshipCertificateGeneralSection: CitizenshipCertificateGeneralFormType = {
  ...commonGeneralFields,
};

export type CitizenshipCertificateDetailsDto = Omit<
  PersonalIdentifierDetails,
  'createdAt' | 'updatedAt'
> & {
  idOfficialName?: string;
};

type CitizenshipCertificateDetailsHelp = {
  idOfficialName?: QuestionType.TEXT;
};

export type CitizenshipCertificateDetailsFormType = Omit<
  PersonalIdentifierDetailsFormType,
  'other'
> &
  TDtoWrapper<CitizenshipCertificateDetailsDto, CitizenshipCertificateDetailsHelp>;

export const CitizenshipCertificateDetailsSection: CitizenshipCertificateDetailsFormType = {
  idOfficialName: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:citizenshipCertificate.inputs.idOfficialName.label',
    value: '',
    capitalized: true,
    order: -1,
  },
  ...omit(commonDetailsFields, 'other'),
};

export const CitizenshipCertificateLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const CitizenshipCertificateFormSections = [
  CitizenshipCertificateGeneralSection,
  CitizenshipCertificateDetailsSection,
  CitizenshipCertificateLegalizedCopiesSection,
];
